import React from "react";
import { Box, Button, Grid, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import Chip from "@mui/material/Chip";
import InfoIcon from "@mui/icons-material/Info";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LabelTwoToneIcon from "@mui/icons-material/LabelTwoTone";

import Application from "./InfoCard/Application";
import Applicationprice from "./InfoCard/Applicationprice";
import Runninghours from "./InfoCard/Runninghours";
import Storageprice from "./InfoCard/Storageprice";
import Typeprice from "./InfoCard/Typeprice";
import Loadbalancer from "./InfoCard/LoadBalancer";

const CurrentSchedule = (props) => {
  const {
    name,
    app,
    appPrice,
    type,
    storage,
    loadBalancer,
    overallprice,
    runninghours,
  } = props;
  const [open, setOpen] = React.useState(false);
  const fullWidth = true;
  const maxWidth = "md";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="More Info" arrow>
        <Button onClick={handleClickOpen} sx={{ borderRadius: '50px', minWidth: 0, px: 1, py: 0.5 }} aria-label="More Info">
          <InfoIcon />
        </Button>
      </Tooltip>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            maxHeight: { xs: '100vh', sm: '90vh' },
            overflow: 'hidden',
          }
        }}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip
            color="primary"
            icon={<LabelTwoToneIcon />}
            label={`Lab name: ${name}`}
          />
          <Box component="span" sx={{ color: 'red', fontWeight: 600, ml: 1 }}>
            Total Credits: {overallprice}
          </Box>
        </DialogTitle>
        <DialogContent sx={{ 
          px: { xs: 1.25, sm: 2.5 }, 
          py: { xs: 0.75, sm: 1.25 },
          overflowY: 'hidden',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' }
        }}>
          <Grid
  container
  spacing={1.5} // reduce spacing between boxes
  rowSpacing={1.5}
  alignItems="stretch"
  justifyContent="center"
  sx={{
    mt: 0.5, // reduce top margin
    mb: 0.5, // reduce bottom margin
  }}
>
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <Application app={app} />
  </Grid>
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <Runninghours runninghours={runninghours} />
  </Grid>
</Grid>

<Grid
  container
  spacing={1.5}
  rowSpacing={1.5}
  alignItems="stretch"
  justifyContent="center"
  sx={{ mt: 0.5, mb: 0.5 }}
>
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <Applicationprice appPrice={appPrice} />
  </Grid>
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <Typeprice type={type} />
  </Grid>
</Grid>

<Grid
  container
  spacing={1.5}
  rowSpacing={1.5}
  alignItems="stretch"
  justifyContent="center"
  sx={{ mt: 0.5, mb: 0.5 }}
>
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <Storageprice storage={storage} />
  </Grid>
  {loadBalancer !== 0 && (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Loadbalancer loadBalancer={loadBalancer} />
    </Grid>
  )}
</Grid>

        </DialogContent>
        <DialogActions sx={{ px: { xs: 1.5, sm: 3 }, pb: { xs: 1, sm: 2 } }}>
          <Tooltip title="Close" arrow>
            <Button onClick={handleClose} color="primary" variant="contained" sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }} aria-label="Close">
              Close
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default CurrentSchedule;
